import { render, staticRenderFns } from "./ShareWarningPrompt.vue?vue&type=template&id=40ccb7c6"
import script from "./ShareWarningPrompt.vue?vue&type=script&lang=ts"
export * from "./ShareWarningPrompt.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports